export const PRODUCTIVE_INTAKE_SETUP_COPY = {
  pageTitle: "How should Productive tasks become tasks?",
  wizardStepConnect: "Connect Productive",
  wizardStepConnectHelper: "Connect Productive so SuperPlane can read tasks and receive new task events.",
  wizardStepConnectExisting: "Choose the Productive account that SuperPlane will monitor.",
  wizardStepProject: "Which Productive project should create tasks?",
  wizardStepProjectHelper: "SuperPlane listens for new tasks.",
  importExistingHelper: "SuperPlane adds up to 3 of the newest open tasks from this project.",
  importExistingHelperOff: "SuperPlane does not import existing tasks.",
  wizardConnect: "Connect Productive",
  wizardConnectAnother: "Connect another account",
  wizardContinue: "Continue",
  wizardFinish: "Finish",
  wizardFinishing: "Finishing...",
  wizardConnectionsLoading: "Loading Productive connections...",
  wizardProjectsLoading: "Loading Productive projects...",
  wizardProjectsError: "SuperPlane could not load Productive projects.",
  wizardProjectsErrorHint: "If this continues, make sure that the connection is still valid.",
  wizardProjectsEmpty: "This connection has no available projects.",
  wizardRetry: "Try again",
  wizardCheckConnection: "Check connection",
  wizardCreateError: "SuperPlane could not create the Productive intake.",
  connectionError: "SuperPlane could not connect Productive. Check the token and try again.",
} as const;
